/*rutas de dimenu*/
import dash from './dimenu/paths_dimenu_parent.js' 
let rutas_dimenu=dash;
export default rutas_dimenu;